import { CirclePlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface AddInvoiceLineButtonProps {
  /** Caller-provided copy keeps create and edit terminology independent. */
  label: string;
  onAddOverhead: () => void;
  onAddMember: () => void;
}

/** Presents the same member/overhead line menu in invoice creation and editing flows. */
export function AddInvoiceLineButton({
  label,
  onAddOverhead,
  onAddMember,
}: AddInvoiceLineButtonProps) {
  const { t } = useTranslation('authenticated.invoices', {
    keyPrefix: 'new.overhead',
  });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          className="h-9 select-none gap-2 px-3 py-2 text-sm font-medium"
          onClick={event => event.stopPropagation()}
        >
          <CirclePlusIcon size={16} />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem onClick={onAddOverhead}>{t('addOverhead')}</DropdownMenuItem>
        <DropdownMenuItem onClick={onAddMember}>{t('addMember')}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
